export type NavKey = 'j' | 'k' | 'ArrowDown' | 'ArrowUp';

/**
 * Next selected tile index given the current one.
 * `current < 0` means "nothing selected yet" — the first press lands on 0 for all keys.
 * `cols` is the live column count (Feed.svelte measures it from the DOM).
 *
 * All four keys clamp to the grid bounds (prototype parity): j/k step by one,
 * ArrowDown/ArrowUp step by a full row.
 */
export function nextIndex(current: number, key: NavKey, total: number, cols: number): number {
  if (total <= 0) return -1;
  if (current < 0) return 0;

  switch (key) {
    case 'j':
      return Math.min(total - 1, current + 1);
    case 'k':
      return Math.max(0, current - 1);
    case 'ArrowDown':
      return Math.min(total - 1, current + cols);
    case 'ArrowUp':
      return Math.max(0, current - cols);
  }
}
